// export default () => ({
// })

export default () => ({
    stafferstype: [],
    stafferstypeSelectable: [],
    stafferstypePaginatedData: null,
    staffertype: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null
})